"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.string.sub.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.splice.js");

var _kline = require("@/model/exchange/kline.js");

var _settings = require("@/model/settings");

var _vueEcharts = _interopRequireDefault(require("vue-echarts"));

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _vuex = require("vuex");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var subMap = {};
window.PageData = {};

function resolveSymbol(pair) {
  if (pair) {
    pair = pair.toLowerCase();
  }

  return pair.replace(/\//, "_");
}

window.resolveKlineDataV3 = function (body) {
  var data = body.data,
      params = body.params;
  var c = data.c,
      h = data.h,
      l = data.l,
      o = data.o,
      t = data.t,
      v = data.v;
  var symbol = params.p,
      resolution = params.r;

  if (t && t.length) {
    if (t.length > 10) {
      return;
    } // 处理后台返回的1天重复数据
    // if (t && t.length == 1 && resolution == "D") {
    //   t[0] = t[0] - 86400;
    // }


    var subMapItem = subMap["".concat(symbol, "_").concat(resolution)];

    if (!subMapItem) {
      return;
    }

    var lastBar = subMapItem.lastBar,
        listener = subMapItem.listener;

    for (var i = 0; i < c.length; i++) {
      var moreTime = historyProvider.timeToSec[resolution];

      if (resolution == "M") {
        moreTime = moreTime * 28;
      }

      var item = {};
      item.close = Number(c[i]);
      item.high = Number(h[i]);
      item.low = Number(l[i]);
      item.open = Number(o[i]);
      item.volume = Number(v[i]);
      item.time = Number(t[i] * 1000) + moreTime;
      var langBarTime = lastBar.time;

      if (langBarTime && item.time >= langBarTime) {
        subMap["".concat(symbol, "_").concat(resolution)].lastBar = Object.assign({}, item);
        listener(item);
      }
    }
  }
};

var historyProvider = {
  getDaysInMonth: function getDaysInMonth(milliseconds) {
    var date = new Date(milliseconds);
    var year = date.getFullYear();
    var month = date.getMonth();
    var temp = new Date(year, month, 0);
    return temp.getDate();
  },
  history: {},
  resolveResolutions: {
    1: "1min",
    5: "5min",
    30: "30min",
    60: "60min",
    240: "4hour",
    D: "1day",
    W: "1week",
    M: "1mon"
  },
  timeToSec: {
    1: 0,
    5: 0,
    15: 0,
    30: 0,
    60: 0,
    240: 0,
    D: 0,
    W: 0,
    M: 24 * 60 * 60 * 1000
  },
  resolveResolutionFun: function resolveResolutionFun(chartResolution) {
    return this.resolveResolutions[chartResolution];
  },
  // getBars执行的次数
  loadTime: 0,
  getBars: function getBars(symbolInfo, chartResolution, from, to, onHistoryCallback, firstDataRequest) {
    this.loadTime++;
    var symbol = resolveSymbol(symbolInfo.name);
    var req = {
      symbol: symbol,
      resolution: chartResolution,
      from: from,
      to: to
    };

    if (req.symbol == "aa") {
      req.symbol = 1010;
    }

    var me = this;

    function resolveHistoryData(rs) {
      var newBars = [];

      if (rs && rs.length) {
        var len = rs.length;

        for (var i = 0; i < len; i++) {
          var moreTime = me.timeToSec[chartResolution];

          if (chartResolution == "M") {
            moreTime = moreTime * 28;
          }

          var _rs$i = rs[i],
              c = _rs$i.c,
              h = _rs$i.h,
              l = _rs$i.l,
              o = _rs$i.o,
              t = _rs$i.t,
              v = _rs$i.v;
          var entry = {};
          entry.close = c;
          entry.high = h;
          entry.low = l;
          entry.open = o;
          entry.volume = v;
          entry.time = t * 1000 + moreTime;
          newBars.push(entry);
        }

        if (firstDataRequest) {
          var lastBar = Object.assign({}, newBars[newBars.length - 1]);
          me.history[symbolInfo.name] = lastBar;
        }

        onHistoryCallback(newBars, {
          noData: false
        });
      } else {
        onHistoryCallback([], {
          noData: true
        });
      }
    }

    (0, _kline.apiHistoryData)(req).then(function (rs) {
      resolveHistoryData(rs.data.kline);
    }); // if (this.loadTime == 1) {
    //   resolveHistoryData(window.PageData.firstHistoryData);
    // } else {
    //   apiHistoryData(req).then(rs => {
    //     resolveHistoryData(rs.data.kline);
    //   });
    // }
  }
};
var stream = {
  loadTime: 0,
  subScribeBars: function subScribeBars(symbolInfo, resolution, onRealtimeCallback, subscribeUID) {
    this.loadTime++;

    if (this.loadTime != 1) {
      var req = {
        action: "Topic.sub",
        data: {
          type: "kline",
          symbol: symbolInfo.name,
          resolution: resolution
        }
      };
      window.ws.sub(req);
    }

    var lastBar = {};

    if (historyProvider.history[symbolInfo.name]) {
      lastBar = historyProvider.history[symbolInfo.name];
    }

    subMap[subscribeUID] = {
      lastBar: lastBar,
      listener: onRealtimeCallback,
      resolution: resolution,
      name: symbolInfo.name
    };
  },
  unsubScribeBars: function unsubScribeBars(subscribeUID) {
    var req = {
      action: "Topic.unsub",
      data: {
        type: "kline",
        symbol: subMap[subscribeUID].name,
        resolution: subMap[subscribeUID].resolution
      }
    };
    window.ws.sub(req);
    delete subMap[subscribeUID];
  }
};
var _default2 = {
  mixins: [_commonMixin.default],
  components: {
    "v-chart": _vueEcharts.default
  },
  props: {
    coinFrom: {
      type: String,
      defalut: ""
    },
    coinTo: {
      type: String,
      defalut: ""
    },
    symbol: {
      type: String,
      default: ""
    },
    depthList: {
      type: Object,
      default: function _default() {
        return {
          a: [],
          b: []
        };
      }
    }
  },
  data: function data() {
    return {
      loading: true,
      arrDeep1: [],
      arrDeep2: [],
      depthListTemp: [],
      deepOptions: {
        backgroundColor: "#fff",
        title: {
          text: ""
        },
        tooltip: {
          trigger: "axis",
          formatter: function formatter(params) {
            var cumulative = "0";

            if (params[0].value[1] >= 1000000000) {
              cumulative = (params[0].value[1] / 1000000000).toFixed(2) + "B";
            } else if (params[0].value[1] >= 1000000) {
              cumulative = (params[0].value[1] / 1000000).toFixed(2) + "M";
            } else if (params[0].value[1] >= 1000) {
              cumulative = (params[0].value[1] / 1000).toFixed(2) + "K";
            } else {
              cumulative = parseFloat(params[0].value[1]).toFixed(2) + "";
            }

            var text = "".concat(params[0].value[2], "<br />").concat(params[0].value[0], "<br />").concat(params[0].value[3], "<br />").concat(cumulative);
            return text;
          },
          position: function position(point, params, dom, rect, size) {
            return [point[0], point[1] - 110];
          },
          axisPointer: {
            type: "line",
            axis: "x" // lineStyle: {
            //   color: "#000",
            //   type: "dashed",
            // },
            // crossStyle: {
            //   color: "#333",
            //   // type: "dashed",
            // },
            // label: {
            //   show: true, //坐标指示器
            //   fontSize: 11,
            //   backgroundColor: "#EEEEEE",
            // },

          }
        },
        grid: {
          containLabel: true,
          left: "0%",
          right: "1%",
          bottom: "10%"
        },
        textStyle: {
          color: "#BBBBBB"
        },
        animation: false,
        xAxis: {
          type: "category",
          boundaryGap: false,
          min: "dataMin",
          axisLine: {
            lineStyle: {
              color: "transparent"
            }
          },
          axisLabel: {
            margin: 8,
            align: "center",
            showMaxLabel: false,
            showMinLabel: false //不显示X轴最小刻度

          },
          axisTick: {
            show: true,
            length: 4,
            lineStyle: {
              color: "#CCCCCC",
              type: "solid" // width: 1,

            }
          },
          show: true
        },
        yAxis: {
          splitNumber: 2,
          zlevel: -1,
          nameTextStyle: {
            fontSize: 10,
            color: "#CCCCCC"
          },
          offset: 0,
          //min: 'dataMin',
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            inside: false,
            lineStyle: {
              color: "#BBBBBB",
              type: "solid",
              width: 1
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 10,
            color: "#BBBBBB",
            inside: false,
            width: 25,
            formatter: function formatter(value) {
              if (value >= 1000000000) {
                return (value / 1000000000).toFixed(2) + "B";
              } else if (value >= 1000000) {
                return (value / 1000000).toFixed(2) + "M";
              } else if (value >= 1000) {
                return (value / 1000).toFixed(2) + "K";
              } else {
                return value;
              }
            }
          },
          position: "right"
        },
        series: [{
          name: "buy",
          showSymbol: false,
          symbol: "circle",
          zlevel: -21,
          label: {
            show: false,
            distance: 22,
            color: "#000000",
            fontSize: 12,
            align: "center",
            verticalAlign: "middle",
            backgroundColor: "#EEEEEE",
            padding: [10, 15, 10, 15]
          },
          symbolSize: 8,
          connectNulls: true,
          emphasis: {},
          lineStyle: {},
          type: "line",
          itemStyle: {
            normal: {
              color: "rgba(2,204,135,0.8)"
            }
          },
          areaStyle: {
            normal: {
              color: "rgba(2,204,135,0.1)"
            }
          },
          data: []
        }, {
          name: "sell",
          showSymbol: false,
          symbol: "circle",
          label: {
            show: false,
            distance: 22,
            color: "#fff",
            fontSize: 12,
            align: "center",
            verticalAlign: "middle",
            backgroundColor: "#222E5D",
            padding: [10, 15, 10, 15]
          },
          symbolSize: 8,
          connectNulls: true,
          //step:true,
          type: "line",
          stack: "总量",
          itemStyle: {
            normal: {
              color: "rgba(198,27,61,0.8)"
            }
          },
          areaStyle: {
            normal: {
              color: "rgba(198,27,61,0.1)"
            }
          },
          data: []
        }]
      },
      asks: [],
      bids: [],
      option: null,
      chartDom: null,
      myChart: null,
      studies: [],
      widget: null,
      pricescale: 100,
      currResolution: "15",
      currChartType: 1,
      symbol_id: "",
      coinConfig: {},
      pageLoading: true,
      symbolMap: {},
      currViewType: 1,
      viewType: [{
        value: "1",
        label: "K线图"
      }, {
        value: "2",
        label: "深度图"
      }],
      resolutionList: [{
        key: 1,
        type: 3,
        value: "1",
        label: "分时"
      }, {
        key: 2,
        type: 1,
        value: "1",
        label: "1分钟"
      }, {
        key: 3,
        type: 1,
        value: "5",
        label: "5分钟"
      }, {
        key: 4,
        type: 1,
        value: "15",
        label: "15分钟"
      }, {
        key: 5,
        type: 1,
        value: "30",
        label: "30分钟"
      }, {
        key: 6,
        type: 1,
        value: "60",
        label: "1小时"
      }, {
        key: 7,
        type: 1,
        value: "240",
        label: "4小时"
      }, {
        key: 8,
        type: 1,
        value: "D",
        label: "1天"
      }, {
        key: 9,
        type: 1,
        value: "W",
        label: "1周"
      }, {
        key: 10,
        type: 1,
        value: "M",
        label: "1月"
      }]
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTradePairList();

            case 2:
              _this.getSymbolInfo();

              _this.pageLoading = true;

              _this.initChart();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {// this.drawLine();
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    language: "user/language"
  })),
  watch: {
    depthList: function depthList() {
      if (this.currViewType == 2) {
        this.depthListTemp = JSON.parse(JSON.stringify(this.depthList));
        this.depthMe(this.depthListTemp.b, this.depthListTemp.a);
        this.deepOptions.series[0].data = this.arrDeep1;
        this.deepOptions.series[1].data = this.arrDeep2;
        this.$refs.deepechart.setOption(this.deepOptions, false, true);
      }
    }
  },
  methods: {
    //数组排序，从大到小
    sortarr: function sortarr(list) {
      function sortNumbersub(a, b) {
        return Number(b[0]) - Number(a[0]);
      }

      list.sort(sortNumbersub);
      return list;
    },
    //数组去重复
    unique: function unique(arr) {
      var newArr = [arr[0]];

      for (var i = 1; i < arr.length; i++) {
        var repeat = false;

        for (var j = 0; j < newArr.length; j++) {
          if (arr[i] === newArr[j]) {
            repeat = true;
            break;
          } else {}
        }

        if (!repeat) {
          newArr.push(arr[i]);
        }
      }

      return newArr;
    },
    //引入买卖数据，然后去除暂时无用的第三位，并且通过reverse()方法倒序内容，让数量显示在第一位
    depthMe: function depthMe(arr1, arr2) {
      var bids = [];
      var asks = [];

      for (var i = 0; i < arr1.length; i++) {
        bids.push(arr1[i].splice(0, 2).map(Number).reverse()); //取数组内容前两位，再倒序，变为数量排在前面用来作为排序字段。
      }

      for (var _i = 0; _i < arr2.length; _i++) {
        asks.push(arr2[_i].splice(0, 2).map(Number).reverse());
      }

      this.k_chart(bids, asks);
    },
    //在渲染成统计图渲染之前，最后再处理一次
    k_chart: function k_chart(bidsTemp, asksTemp) {
      for (var i = 0; i < bidsTemp.length; i++) {
        var tempB = 0; // let tempString = " ";

        for (var j = 0; j < bidsTemp.length; j++) {
          if (bidsTemp[i][1] >= bidsTemp[j][1]) {
            tempB += bidsTemp[j][0];
          }
        } // console.log(tempString);


        bidsTemp[i][0] = tempB.toFixed(4);
      }

      asksTemp = asksTemp.reverse();

      for (var _i2 = 0; _i2 < asksTemp.length; _i2++) {
        var _tempB = 0;

        for (var _j = 0; _j < asksTemp.length; _j++) {
          if (asksTemp[_i2][1] >= asksTemp[_j][1]) {
            _tempB += asksTemp[_j][0];
          }
        }

        asksTemp[_i2][0] = _tempB.toFixed(4);
      }

      asksTemp = asksTemp.reverse();
      var bids = this.sortarr(bidsTemp); //以数量从小到大排序

      var asks = this.sortarr(asksTemp).reverse(); //排序之后再倒过来，变成从大到小

      this.arrDeep1 = [];
      this.arrDeep2 = [];

      for (var _i3 = 0; _i3 < bids.length; _i3++) {
        this.arrDeep1.push(bids[_i3].splice(0, 2).reverse()); //将价格重新变为内容数组第一位
      }

      for (var _i4 = 0; _i4 < asks.length; _i4++) {
        this.arrDeep2.push(asks[_i4].splice(0, 2).reverse());
      }

      for (var _i5 = 0; _i5 < bids.length; _i5++) {
        this.arrDeep1[_i5][2] = this.translateTitle("\u59D4\u6258\u4EF7");
        this.arrDeep1[_i5][3] = this.translateTitle("\u7D2F\u8BA1\u6DF1\u5EA6");
      }

      for (var _i6 = 0; _i6 < asks.length; _i6++) {
        this.arrDeep2[_i6][2] = this.translateTitle("\u59D4\u6258\u4EF7");
        this.arrDeep2[_i6][3] = this.translateTitle("\u7D2F\u8BA1\u6DF1\u5EA6");
      } // this.arrDeep1 = this.unique(this.arrDeep1);
      // this.arrDeep2 = this.unique(this.arrDeep2);
      //最终得出的arr1和arr2就可以去用来渲染深度图了

    },
    getTradePairList: function getTradePairList() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$apiGetStaticTa, status, data, tempObj, key;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(49);

              case 2:
                _yield$apiGetStaticTa = _context2.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  tempObj = data;

                  for (key in tempObj) {
                    _this2.$set(_this2.symbolMap, tempObj[key].symbol.toLowerCase(), tempObj[key].symbol_id);
                  }

                  _this2.symbol_id = _this2.symbolMap[_this2.symbol];
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    showStudy: function showStudy(widget) {
      // 添加ma指标
      widget.chart().createStudy("Moving Average", false, false, [5], null, {
        "Plot.color": "#642d92"
      });
      widget.chart().createStudy("Moving Average", false, false, [10], null, {
        "Plot.color": "#5278a3"
      });
      widget.chart().createStudy("Moving Average", false, false, [30], null, {
        "Plot.color": "#238031"
      });
      widget.chart().createStudy("Moving Average", false, false, [60], null, {
        "Plot.color": "#850058"
      });
    },
    getSymbolInfo: function getSymbolInfo() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, _yield$apiSymbolInfo, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  symbol: _this3.symbol_id
                }; // 获取26静态表 获取交易对精度

                _context3.next = 3;
                return (0, _kline.apiSymbolInfo)(params);

              case 3:
                _yield$apiSymbolInfo = _context3.sent;
                status = _yield$apiSymbolInfo.status;
                data = _yield$apiSymbolInfo.data;

                if (status == 200) {
                  _this3.coinConfig = data;
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onChangeSymbol: function onChangeSymbol(item) {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var symbol, interval;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.symbol_id = item.symbol_id;
                _context4.next = 3;
                return _this4.getSymbolInfo();

              case 3:
                symbol = item.symbol_id;

                if (_this4.widget && _this4.widget.chart) {
                  interval = _this4.widget.chart().resolution();

                  _this4.widget.setSymbol(String(symbol), interval, function () {
                    // 此种情况服务端无返回数据
                    _this4.widget.chart().getVisibleRange();
                  });
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onViewChange: function onViewChange(value) {
      this.currViewType = value;
    },
    onResolutionChange: function onResolutionChange(item) {
      var _this5 = this;

      this.pageLoading = true;
      var type = item.type,
          value = item.value;

      if (this.currResolution == 1 && value == 1) {
        this.widget.chart().setChartType(type);
      } else {
        this.widget.chart().setResolution(value, function () {
          _this5.widget.chart().setChartType(type);
        });
      }

      var state = type == 3 ? 0 : 1;

      for (var i = 0; i < this.studies.length; i++) {
        this.widget.chart().getStudyById(this.studies[i]).setVisible(state);
      }

      this.currResolution = value;
      this.currChartType = type;
      this.pageLoading = false;
    },
    //自动判断选择时区
    selectTimeZone: function selectTimeZone() {
      //可能需要进行判断
      return _momentTimezone.default.tz.guess();
    },
    // 初始化
    initChart: function initChart() {
      var _this6 = this;

      this.pageLoading = true;
      var langMap = {
        // zh_CN: "zh",
        // zh_HK: "zh_TW",
        // en: "en",
        // kr: "ko",
        // jp: "ja",
        // ru: "ru",
        zh_CN: "zh",
        zh_HK: "zh_TW",
        en: "en",
        ko: "ko",
        ja: "ja",
        ru: "ru"
      };
      var locale = langMap[this.language] || "en";
      var backgroundColor = "#fff";
      var lineColor = "#fff";
      var gapLineColor = "#f2f3f4";
      var textColor = "#6e86a8";
      var interval = this.currResolution;
      var widget = new window.TradingView.widget({
        debug: false,
        symbol: this.symbol_id,
        interval: interval,
        theme: "light",
        toolbar_bg: "transparent",
        container_id: "tv_chart_container",
        datafeed: {
          onReady: function onReady(cb) {
            var config = {
              supported_resolutions: ["1", "5", "15", "30", "60", "240", "D", "W", "M"]
            };
            setTimeout(function () {
              return cb(config);
            }, 0);
          },
          resolveSymbol: function resolveSymbol(symbolName, onSymbolResolveCallback) {
            var symbol_stub = {
              // 交易对名称
              name: symbolName,
              ticker: symbolName,
              discription: "",
              exchange: "Topcreditbank",
              has_intraday: true,
              minmov: _this6.coinConfig.minmov,
              minmove2: _this6.coinConfig.minmove2,
              pricescale: _this6.coinConfig.pricescale,
              session: "24x7",
              timezone: _this6.coinConfig.timezone,
              has_weekly_and_monthly: true,
              // 无数据显示空的k柱
              has_empty_bars: true
            };
            setTimeout(function () {
              onSymbolResolveCallback(symbol_stub);
            }, 0);
          },
          getBars: function getBars(symbolInfo, resulution, from, to, onHistoryCallback, firstDataRequest) {
            historyProvider.getBars(symbolInfo, resulution, from, to, onHistoryCallback, firstDataRequest);
          },
          subscribeBars: function subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback) {
            stream.subScribeBars(symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback);
          },
          unsubscribeBars: function unsubscribeBars(subscribeUID) {
            stream.unsubScribeBars(subscribeUID);
          }
        },
        // library_path: `https://help.topcreditbank.com/3rd/tradingview/charting_library/`,
        // library_path: `${process.env.VUE_APP_UCENTER}/3rd/tradingview/charting_library/`,
        library_path: "/3rd/tradingview/charting_library/",
        locale: locale,
        autosize: true,
        timezone: this.selectTimeZone(),
        disabled_features: ["use_localstorage_for_settings", "header_screenshot", "header_symbol_search", "header_undo_redo", "header_compare", "timeframes_toolbar", "header_chart_type", // 头部分辨率
        "header_resolutions", "header_widget", // kline与成交量是否重合
        "volume_force_overlay", // "left_toolbar",
        // 移动端禁用属性
        "property_pages", "show_chart_property_page" // 禁用右键菜单
        // "context_menus",
        ],
        overrides: {
          volumePaneSize: "small",
          "paneProperties.topMargin": 15,
          "paneProperties.bottomMargin": 10,
          // 背景颜色
          "paneProperties.background": backgroundColor,
          // // 水平分割线
          "paneProperties.vertGridProperties.color": gapLineColor,
          "paneProperties.vertGridProperties.style": 0,
          // // 竖直分割线
          "paneProperties.horzGridProperties.color": gapLineColor,
          "paneProperties.horzGridProperties.style": 0,
          // // 蜡烛线涨颜色
          "mainSeriesProperties.candleStyle2.wickUpColor": "#00b464",
          "mainSeriesProperties.candleStyle2.upColor": "#00b464",
          "mainSeriesProperties.candleStyle2.borderUpColor": "#00b464",
          // // 蜡烛线跌颜色
          "mainSeriesProperties.candleStyle.wickDownColor": "#fa4d56",
          "mainSeriesProperties.candleStyle.downColor": "#fa4d56",
          "mainSeriesProperties.candleStyle.borderDownColor": "#fa4d56",
          //面积图测试
          "mainSeriesProperties.areaStyle.color1": "rgba(40, 186, 152, 0.25)",
          "mainSeriesProperties.areaStyle.color2": "rgba(255, 255, 255, 0.23)",
          "mainSeriesProperties.areaStyle.linecolor": "#24B391",
          // 横纵坐标的字体大小
          "scalesProperties.fontSize": 12,
          // 横纵坐标线条的颜色
          "scalesProperties.lineColor": lineColor,
          // kline上面字体显示的颜色
          "scalesProperties.textColor": textColor,
          // 默认隐藏左上角标题，可手动打开
          "paneProperties.legendProperties.showLegend": false,
          // 展示开盘价，最高价，最低价，收盘价
          "paneProperties.legendProperties.showSeriesOHLC": true // "paneProperties.legendProperties.showStudyArguments": true,
          // "paneProperties.legendProperties.showStudyTitles": true,
          // "paneProperties.legendProperties.showStudyValues": true,
          // "paneProperties.legendProperties.showSeriesTitle": true,
          // "paneProperties.legendProperties.showSeriesOHLC": true,
          // "paneProperties.legendProperties.showLegend": true,
          // "paneProperties.legendProperties.showBarChange": true,
          // "paneProperties.legendProperties.showOnlyPriceSource": true,

        },
        studies_overrides: {
          "volume.volume.color.0": "#DA3D68",
          "volume.volume.color.1": "#24B391",
          "volume.show ma": true,
          "volume.volume ma.plottype": "line",
          "volume.ma length": 5,
          "volume.volume ma.color": "#FF0000",
          //波浪图颜色
          "volume.volume ma.transparency": 100,
          //波浪图透明度
          "volume.volume ma.linewidth": 5,
          "volume.show ma": true //是否显示

        },
        customFormatters: {
          timeFormatter: {
            format: function format(date) {
              var _format_str = "%h:%m";
              return _format_str.replace("%h", date.getUTCHours() < 10 ? "0".concat(date.getUTCHours()) : date.getUTCHours(), 2).replace("%m", date.getUTCMinutes() < 10 ? "0".concat(date.getUTCMinutes()) : date.getUTCMinutes(), 2);
            }
          },
          dateFormatter: {
            format: function format(date) {
              return "".concat(date.getUTCFullYear(), "-").concat(date.getUTCMonth() + 1 < 10 ? "0".concat(date.getUTCMonth() + 1) : date.getUTCMonth() + 1, "-").concat(date.getUTCDate() < 10 ? "0".concat(date.getUTCDate()) : date.getUTCDate());
            }
          }
        },
        custom_css_url: "trading_view3.css"
      });
      widget.onChartReady(function () {
        //JQG 获取平均值ID
        // 添加ma指标
        var id = widget.chart().createStudy("Moving Average", false, false, [5], null, {
          "Plot.color": "#642d92"
        });

        _this6.studies.push(id);

        id = widget.chart().createStudy("Moving Average", false, false, [10], null, {
          "Plot.color": "#5278a3"
        });

        _this6.studies.push(id);

        id = widget.chart().createStudy("Moving Average", false, false, [30], null, {
          "Plot.color": "#238031"
        });

        _this6.studies.push(id);

        id = widget.chart().createStudy("Moving Average", false, false, [60], null, {
          "Plot.color": "#850058"
        });

        _this6.studies.push(id);
      });
      this.widget = widget;
    }
  }
};
exports.default = _default2;